document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".buy-now-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const variantId = btn.dataset.variantId;
      const productUrl = btn.dataset.url;
      if (!variantId && !productUrl) return;
      
      // Redireciona direto para checkout somente deste item
      const redirect = btn.classList.contains("bundler") ? productUrl : `/cart/${variantId}:1?checkout`;
      window.location.href = redirect;
    });
  });
});